import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ApiObjectData } from '../models/api-object-data';
import { Language } from '../models/language';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {

  controller = 'language';

  constructor(
    private translate: TranslateService,
    private baseService: BaseService
  ) { }

  get(id): Observable<ApiObjectData> {
    return this.baseService.get(id, this.controller);
  }

  gets(): Observable<ApiObjectData> {
    return this.baseService.gets(this.controller);
  }

  save(obj: Language) {
    return this.baseService.save(this.controller, obj);
  }

  remove(id: number) {
    console.log(id);
    return this.baseService.remove(this.controller, id);
  }
  // get_language
  getLanguage() {
    const lang = document.getElementById('language').innerText;
    return lang;
  }
  // set_language
  setLanguage(lang) {
    this.baseService.lang = lang;
    localStorage.setItem('lang', this.baseService.lang);
  }
  // set_layout
  setLayout(newLayout, oldLayout) {
    this.baseService.dir = newLayout;
    localStorage.setItem('dir', this.baseService.dir);
  }
}
